import styled, { css } from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IWLiveSectionProps {
  $bgColor?: string;
  $textColor?: string;
  $pointColor?: string;
  $emphasisTextColor?: string;
}

export const WLiveSection = styled.div<IWLiveSectionProps>`
  background: #fff;
  padding: 32px 0;

  ${({ $bgColor }) =>
    $bgColor &&
    css`
      background: ${$bgColor};
    `}

  .section-title {
    padding-bottom: 12px;
  }

  &.bg-type-black {
    background: #000;

    .main-title {
      color: #fff;
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    padding: ${mixin.pxToVw('32 0')};

    .section-title {
      padding-bottom: ${mixin.pxToVw('12')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    padding: 65px 0;

    .section-title {
      width: var(--pc-width);
      margin: 0 auto;
      padding-bottom: 20px;
    }

    .live-item-wrap {
      width: var(--pc-width);
      margin: 0 auto;

      .swiper-slide {
        overflow: hidden;
      }
    }
  }
`;

export const TabMenu = styled.div`
  margin-bottom: 20px;

  .tab-list {
    .swiper {
      padding: 0 20px;

      .swiper-wrapper {
        align-items: center;

        .swiper-slide {
          width: auto !important;

          &:last-child {
            margin-right: 0 !important;
          }
        }
      }
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    margin-bottom: ${mixin.pxToVw('20')};

    .tab-list {
      .swiper {
        padding: ${mixin.pxToVw('0 20')};
      }
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    width: var(--pc-width);
    margin: 0 auto 20px;

    .tab-list {
      ${mixin.flex({ justify: 'start', align: 'center', wrap: 'wrap' })};
      gap: 12px;
    }
  }
`;
